var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "_524cbd31" }, [
    _c("div", { staticClass: "_6f35a76d" }, [
      _c(
        "header",
        { staticClass: "top-nav", attrs: { id: "topNavBar" } },
        [
          _c(
            "router-link",
            { attrs: { to: { name: "home" }, exact: "" } },
            [_c("sui-image", { attrs: { src: _vm.logo, size: "small" } })],
            1
          ),
          this.$route.name !== "home"
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticClass: "dropdown",
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({ name: "home" })
                        },
                      },
                    },
                    [_vm._m(0)]
                  ),
                  _vm.profileType !== _vm.profileTypes.CLIENT
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "dropdown",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({ name: "lifeImpact" })
                              },
                            },
                          },
                          [
                            _vm._m(1),
                            _c("div", { staticClass: "dropdown-content" }),
                          ]
                        ),
                        _c("div", { staticClass: "dropdown" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "dropbtn" },
                              [
                                _vm._v(" Compliance "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "angle-down" },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "dropdown-content" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: { to: { name: "attestationManager" } },
                                },
                                [_vm._v("Quarterly Attestations")]
                              ),
                              _vm.user.profile.is_super_cco
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { name: "supervisedPersonManager" },
                                      },
                                    },
                                    [_vm._v(" Supervised Persons ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "dropdown" }, [
                          _c("div", [
                            _c("div", { staticClass: "dropbtn" }, [
                              _c(
                                "span",
                                [
                                  _vm._v(" Investments "),
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "angle-down" },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "dropdown-content" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: { to: { name: "cashRequestManager" } },
                                },
                                [_vm._v("Cash Requests")]
                              ),
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: "investmentStrategyManager" },
                                  },
                                },
                                [_vm._v("Investment Strategies")]
                              ),
                              _vm.user.profile.is_investments_user
                                ? [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "firmFeeScheduleManager",
                                          },
                                        },
                                      },
                                      [_vm._v("Firm Fee Schedules")]
                                    ),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: { name: "firmModelManager" },
                                        },
                                      },
                                      [_vm._v("Firm Models")]
                                    ),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: { name: "feeScheduleManager" },
                                        },
                                      },
                                      [_vm._v("Fee Schedule List")]
                                    ),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: { to: { name: "modelManager" } },
                                      },
                                      [_vm._v("Model List")]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                        _c("div", { staticClass: "dropdown" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "dropbtn" },
                              [
                                _vm._v(" Forms "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "angle-down" },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "dropdown-content" },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "clientAgreement" } } },
                                [_vm._v("Client Agreement Profile")]
                              ),
                              _vm.user.profile.profile_type === 2
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "investorProfileView" },
                                          },
                                        },
                                        [_vm._v("Exhibit B - Investor Profile")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "dropdown" }, [
                          _c("div", [
                            _c("div", { staticClass: "dropbtn" }, [
                              _c(
                                "span",
                                [
                                  _vm._v(" Training Resources "),
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "angle-down" },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "dropdown-content" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: "complianceResourceList" },
                                  },
                                },
                                [_vm._v("Compliance")]
                              ),
                              _c(
                                "router-link",
                                { attrs: { to: { name: "faqs" } } },
                                [_vm._v("Frequently Asked Questions")]
                              ),
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: "investmentsResourceList" },
                                  },
                                },
                                [_vm._v("Investments")]
                              ),
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: "operationsResourceList" },
                                  },
                                },
                                [_vm._v("Operations")]
                              ),
                              _c(
                                "router-link",
                                {
                                  attrs: { to: { name: "videosResourceList" } },
                                },
                                [_vm._v("Videos")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "dropdown" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "dropbtn" },
                              [
                                _vm._v(" Support "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "angle-down" },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "dropdown-content" },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "ticketManager" } } },
                                [_vm._v("Help Requests")]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    href: _vm.provisionsGroupSalesforceCommunityPortal,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(" Salesforce Help "),
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "external-link-alt" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "router-link",
                                { attrs: { to: { name: "ticketManager" } } },
                                [_vm._v("Prayer Requests")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "dropdown" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "dropbtn" },
                              [
                                _vm._v(" Links "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "angle-down" },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "dropdown-content" }, [
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: {
                                  href: "https://account.box.com/login",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(" Box "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "external-link-alt" },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: {
                                  href: "https://login.bdreporting.com/",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(" Black Diamond "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "external-link-alt" },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: {
                                  href: "https://my.dimensional.com/login/",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(" Dimensional Fund Advisors "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "external-link-alt" },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: {
                                  href: "https://www.finametrica.com/login.aspx",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(" FinaMetrica "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "external-link-alt" },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: {
                                  href: "https://webaccess.nationaladvisorstrust.com/advisordesk/UserLogin.aspx",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(" National Advisors Trust Company "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "external-link-alt" },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: {
                                  href: "https://login.salesforce.com/",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(" Salesforce "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "external-link-alt" },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: {
                                  href: "https://invest.ameritrade.com/grid/p/login",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(" TD Ameritrade "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "external-link-alt" },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ])
                    : [
                        _c("div", { staticClass: "dropdown" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "dropbtn" },
                              [
                                _vm._v(" Forms "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "angle-down" },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "dropdown-content" },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "clientAgreement" } } },
                                [_vm._v("Client Agreement Profile")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "dropdown" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "dropbtn" },
                              [
                                _vm._v(" Document Vault "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "angle-down" },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "dropdown-content" }, [
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: {
                                  href: "https://eversourcewa.account.box.com/login",
                                  target: "_blank",
                                },
                              },
                              [
                                _c("span", [_vm._v("Box")]),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "external-link-alt" },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a",
                              { staticClass: "item", attrs: { href: "" } },
                              [_vm._v("Investment Policy Statement")]
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "dropdown" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "dropbtn" },
                              [
                                _vm._v(" Account Management "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "angle-down" },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "dropdown-content" }, [
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: {
                                  href: "https://bd3.bdreporting.com",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(" Black Diamond "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "external-link-alt" },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: {
                                  href: "https://www.tdameritrade.com/home.page",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(" TD Ameritrade "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "external-link-alt" },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "dropdown" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "dropbtn" },
                              [
                                _vm._v(" Financial Planning "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "angle-down" },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "dropdown-content" }, [
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: {
                                  href: "https://wealth.emaplan.com/ema/SignIn",
                                  target: "_blank",
                                },
                              },
                              [
                                _c("span", [_vm._v("eMoney Advisor")]),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "external-link-alt" },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({ name: "lifeImpact" })
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "dropbtn" },
                                [
                                  _vm._v(" Life Impact "),
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "angle-down" },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ],
                  _c(
                    "div",
                    {
                      staticClass: "dropdown",
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({ name: "calendar" })
                        },
                      },
                    },
                    [_vm._m(2)]
                  ),
                ],
                2
              )
            : _vm._e(),
          _c("div", [
            _c("div", { staticClass: "dropdown profile" }, [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "dropbtn" },
                  [
                    _c("font-awesome-icon", { attrs: { icon: "user-circle" } }),
                    _vm._v(" " + _vm._s(_vm.displayName) + " "),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "dropdown-content profile-dropdown-content" },
                [
                  _c("router-link", { attrs: { to: { name: "Profile" } } }, [
                    _vm._v("Settings"),
                  ]),
                  _c("a", { on: { click: _vm.logout } }, [_vm._v("Log Out")]),
                ],
                1
              ),
            ]),
            this.$route.name !== "home"
              ? _c("div", [
                  _vm.profileType === _vm.profileTypes.FINANCIAL_ADVISOR ||
                  _vm.profileType === _vm.profileTypes.ADMINISTRATOR
                    ? _c("div", { staticClass: "dropdown setup" }, [
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "dropbtn" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "cog" },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "dropdown-content setup-dropdown-content",
                          },
                          [
                            _vm.user.profile.is_super_admin
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "item",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push({
                                          name: "firmManager",
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticStyle: { "margin-left": "2px" },
                                      attrs: { icon: "building" },
                                    }),
                                    _vm._v(" Firm Management "),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "a",
                              {
                                staticClass: "item",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push({
                                      name: "userManager",
                                    })
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "users" },
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "2px" } },
                                  [_vm._v("User Management")]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _c(
            "a",
            {
              staticClass: "icon",
              staticStyle: { "font-size": "15px" },
              on: {
                click: function ($event) {
                  return _vm.resizeNavBar()
                },
              },
            },
            [_vm._v("☰")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dropbtn" }, [
      _c("div", { staticClass: "_BC7CF055" }, [_vm._v("Home")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dropbtn" }, [
      _c("div", { staticClass: "_BC7CF055" }, [_vm._v("Life Impact®")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "dropbtn" }, [_vm._v("Calendar")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }